<template>
    <gofix-card title=" " classHeader="p-0 m-0" class="heig-frame-child" fullContent>
    <div class="boxShadow bg-white contractSCFaultType noOverflow mb-0 heig-frame-tab">

        <b-form class="pb-20">
            <b-row>
                    <b-col md="auto" class="mb-2" cols="12" lg=6>
                        <gofix-form-dropdown
                                label="Select Role"
                                :options="options_role"
                                v-model="value_role"
                                @change="filterRole"
                                vLabel="name">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="auto" class="mb-2" cols="12" lg=6>
                      <gofix-form-dropdown
                                label="Select Case Status"
                                :options="options_case"
                                v-model="value_case"
                                :multiple="true"
                                vLabel="priority_title"
                                :disabled="switch_roles">
                        </gofix-form-dropdown>
                       
                    </b-col>
                   
                    
                    
            </b-row>

         

             <!-- <b-row>
                    <b-col md="auto" class="mb-2" cols="12" lg=6>
                        <multiselect v-model="value" :options="options" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select Email Status" label="name" track-by="name" :preselect-first="true">
                            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                        </multiselect>
                    </b-col>
             </b-row> -->
           

            <b-row>
                    <b-col md="auto" class="mb-2" cols="12" lg=6>
                         <gofix-form-dropdown
                                label="Select Email Status"
                                :options="options_email_status"
                                v-model="value_email_status"
                                :multiple="true"
                                vLabel="priority_title"
                                :disabled="switch_roles"
                                >
                        </gofix-form-dropdown>
                        
                    </b-col>
                    <b-col md="auto" class="mb-2" cols="12" lg=6>
                        <gofix-form-dropdown
                                label="Select Person-In-Charge"
                                :options="person_in_charge_list"
                                v-model="person_in_charge_value"
                                vLabel="name"
                                :disabled="switch_roles"
                                >
                        </gofix-form-dropdown>
                    </b-col>
                    
                   
            </b-row>

           
            <br>

             <b-row>
                 <b-col md="auto" class="mb-2" cols="12" lg=6>
                    <b-button-group class="btn-group">
                        <!-- <b-button class="custom-btn" @click="modals.delete.open = false">No</b-button> -->
                        <gofix-button class="mr-4" @click="save" label="Submit" ></gofix-button>

                        <!-- <b-button class="custom-btn"  @click="removeNode">  Submit</b-button> -->
                    </b-button-group>
                </b-col>
             </b-row>

        </b-form>
        </div>
   
        <b-modal :no-close-on-backdrop="true" modal-class="createFmCode" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open">
            <b-form class="pb-20">
                <gofix-form-input label="Requestor Type" v-model="modal.data.title" required></gofix-form-input>
                <gofix-form-dropdown
                    label="Requestor Data Type"
                    :clearable="true"
                    :required="true"
                    :show-icon-required="true"
                    v-model="modal.data.data_type"
                    :options="modal.requestorDataType">
                </gofix-form-dropdown>
            </b-form>
            <b-button-group class="d-block text-right">

                <gofix-button label="SUBMIT"  :loading="modal.loading" noBorder ></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" @hidden="hideModel" id="modal-Clone"
            modal-class="default-modal modal-clone-notification"
            title="Clone Master"
            :centered="true"
            scrollable
            :footer-class="'border-0'"
            v-model="modalClone.open">
            <b-form v-if="modalClone.list.length">
                <ul class="listCheck list-unstyled listData">
                    <li>
                        <input class="styled-checkbox" type="checkbox" v-model="modalClone.allSelect">
                        <label></label>
                        <span class="pl-25">Requestor Type</span>
                    </li>
                    <template  v-for="(cl, index) in modalClone.list">
                        <li :key="index">
                            <input v-model="modalClone.select" class="styled-checkbox" type="checkbox" :value="cl.id">
                            <label></label>
                            <span>{{index + 1}}</span>
                            <span>{{cl.title}}</span>
                        </li>
                    </template>
                </ul>
            </b-form>
            <div class="pb-20 text-center" v-if="!modalClone.list.length">
                No Master!
            </div>
            <template #modal-footer>
                <b-button-group class="d-block text-right pr-3">
                    <gofix-button label="SUBMIT" @click="cloneDataFromMater" :loading="modalClone.loading" noBorder></gofix-button>
                </b-button-group>
            </template>
        </b-modal>
    </gofix-card>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
    import Multiselect from 'vue-multiselect';
    export default {
        name: 'case-settings-requester-type',
        components: {
            Multiselect
        },
        props: {
            is_master: {
                require: false,
                default: false
            }
        },
        data () {
            return {
                tableConfig:{
                    name: 'case-settings-requester-type',
                    controls:{
                        createTooptip:"Create Requestor Type",
                        tableImport:false,
                        tableExport:false,
                        tableColumnSettings:false,
                        tableCloneMaster: !this.is_master ?  true : false,
                    },
                    filter: {
                        title:       { type: "text", value: "", function: "ilike", with: [] },
                        data_type:   { type: "text", value: "", function: "ilike", with: [] },
                        contract_id: { type: (!this.is_master ?  "number" : "null"), value: (!this.is_master ?  this.$route.params.id : null), function: "=", with: [] }
                    },
                    page: 1,
                    total: 0,
                    isCMS: 'true',
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "asc",
                    itemSelected: [],
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'title',
                            label: 'Requestor Type',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:400px",
                            sorting: true,
                        },
                        {
                            key: 'data_type',
                            label: 'Requestor Data Type',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:nullpx",
                            sorting: true,
                        },
                    ]
                },
                tableItems:[],
                options_email_status:[],
                value_email_status:[],
                value_case: [],
                options_case:[],
                value_role: [],
                options_role: [],
                person_in_charge_list:[],
                person_in_charge_value:[],
                switch_roles:true,
                filters_exist:false,
                team_lead_checked:false,
                modal: {
                    open: false,
                    loading: false,
                    title:"New Requestor Type",
                    requestorDataType: ["Generic Address", "Company Profile", "Supplier", "Client", "FM Company",  "User Account", "Tenant", "NLT Caller Profile"],
                    data:{
                        id: null,
                        title: null,
                        data_type: null,
                        contract_id: !this.is_master ? this.$route.params.id : null,
                    },
                },
                modalClone : {
                    open: false,
                    allSelect: false,
                    list:[],
                    select:[]
                }
            }
        },
        watch: {
            "modalClone.allSelect": function(val) {
                if (val) {
                    this.modalClone.select = [];
                    for (let i in this.modalClone.list) {
                        this.modalClone.select.push(this.modalClone.list[i].id)
                    }
                }
                if(!val && this.modalClone.list.length == this.modalClone.select.length) {
                    this.modalClone.select = [];
                }
            },
            "modalClone.select": function(val) {
                if(this.modalClone.select.length > 0 && this.modalClone.list.length === this.modalClone.select.length) {
                    this.modalClone.allSelect = true;
                }else{
                    this.modalClone.allSelect = false;
                }
            }
        },
        created() {

            this.$store.dispatch("RoleController/getRoleItems", {
                    page: 1,
                    limit: 100,
                    // sortColumn: "id",
                    // sortDirection: "asc",
                    // isCMS: 1,
                    // filter: {
                    //     contract_id: { type: "null", value: null, function: "=", with: [] }
                    // }
                })
                    .then(response => {
                       
                        this.options_role = response.items;
                        // this.value_role=response.items
                        // resolve(this.$notificationV2('deleting', 'case_requestor_types'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            
        },
        methods:{
            //Load data list
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.contract_id.value = this.$route.params.id;
                await this.$store.dispatch("CaseSettingsController/getListCaseRequestorTypes", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$bvToast.toast("Can not load the data", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                        reject();
                    })
            },
            filterRole()
            {
                if(this.value_role != null)
                {
                    this.$store.dispatch("CaseSettingsController/getListEmailDefaultFilters", {
                    role_id: this.value_role.id,
                    contract_id: this.$route.params.id,
                    })
                    .then(response => {
                        this.filters_exist = response.filters_exist;

                        if(response.filters_exist)
                        {
                            this.switch_roles=false;
                            this.value_email_status=response.email_status.selected;
                            this.value_case=response.case_status.selected;
                            // this.person_in_charge_value=response.user_list.selected;
                            
                        }else{
                            this.switch_roles=false;
                            this.value_email_status=[];
                            this.value_case=[];
                            this.person_in_charge_value=[];
                        }
                        

                        this.team_lead_checked=!response.is_team_lead?false:response.is_team_lead;

                        this.person_in_charge_value=!response.filter_status?[]:[{"name":response.filter_status}];


                        this.options_email_status=response.email_status.list;
                        this.options_case = response.case_status.list;

                        // this.person_in_charge_list=response.user_list.list;
                        this.person_in_charge_list=[{"name":"None"},{"name":"Logged in FM User"}];
                       
                    })
                    .catch(err =>{
                        console.log(err);
                        // reject(err);
                    });

                }
                else
                {
                
                this.switch_roles=true;
                this.value_case=[];
                this.value_email_status=[];
                this.person_in_charge_value=[];
                
                }


            },
            //Open modal Edit || Create data
            openModal(item){
                if(item){
                    this.modal.title = "Edit Requestor Type";
                    this.modal.data = {
                        id: item.id,
                        title: item.title,
                        data_type: item.data_type,
                        contract_id: item.contract_id,
                    }
                }else{
                    this.modal.title = "New Requestor Type";
                    this.modal.data = {
                        id: null,
                        title: null,
                        data_type: null,
                        contract_id: !this.is_master ? this.$route.params.id : null,
                    }
                }
                this.modal.open = true;
            },
            //Update & Create data
            save(){


                // console.log(this.person_in_charge_value);


                // this.modal.loading = true;
                
              
                
                let method    = 'createItemEmailDefaultFilters';
                let msg    = 'adding';
                
                this.$store.dispatch(`CaseSettingsController/${method}`, {
                    role_id:this.value_role.id,
                    contract_id: this.$route.params.id,
                    selected_email_status: !this.value_email_status? null :this.value_email_status.toString(),
                    selected_case_status: !this.value_case? null :this.value_case.toString(),
                    filter_status:this.person_in_charge_value == null ? null : this.person_in_charge_value.name,
                    is_team_lead:this.team_lead_checked,
                })
                    .then(result => {
                        this.$alertNotification(this.$notificationV2(msg, 'filters'));
                        this.modal.loading = false;
                        this.modal.open = false;
                        this.$refs['gofixTable'].reloadTableKeepFilter();
                    })
                    .catch(error => {
                        this.modal.loading = false;
                        if(error.response && error.response.data.error.message.error) {
                            this.$alertNotification(error.response.data.error.message.error, "danger");
                        }
                    })
            },
            //Delete data
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("CaseSettingsController/deteleItemCaseRequestorTypes", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'case_requestor_types'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            // Clone
            getMaster() {
                this.$store.dispatch("CaseSettingsController/getListCaseRequestorTypes", {
                    page: 1,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                    isCMS: 1,
                    filter: {
                        contract_id: { type: "null", value: null, function: "=", with: [] }
                    }
                })
                    .then(response => {
                        this.modalClone.list = response.items;
                    })
                    .catch(err => { })
            },
            hideModel() {
                this.modalClone.allSelect = false;
                this.modalClone.select    = [];
                this.modalClone.list      = [];
            },
            showModalClone() {
                this.getMaster();
                this.modalClone.open = true;
            },
            cloneDataFromMater() {
                this.modalClone.loading = true;
                let data = {
                    contract_id: this.$route.params.id,
                    ids: this.modalClone.select
                };
                this.$store.dispatch("CaseSettingsController/cloneMasterCaseRequestorTypes",data)
                    .then(response => {
                        this.$alertNotification("Successfully Clone");
                        this.modalClone.open = false;
                        this.modalClone.loading = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(error => {
                        let msg = "Clone failed!";
                        if(error.response.data && error.response.data.error && error.response.data.error.message && error.response.data.error.message.error) {
                            msg = error.response.data.error.message.error;
                        }
                        this.$alertNotification(msg, "danger");
                        this.modalClone.loading = false;
                    })
            }
        }
    }
</script>
